export const handleGtmData = function (gtm: Array<unknown>): void {
    window.dataLayer = window.dataLayer || []

    window.dataLayer.push(gtm)
}
